import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {useContext} from 'react'
import {OrderReportContext} from '../../context'
import Search from '../../../../components/Search'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import ExportCSVButton from '../../components/ExportCSVButton'
import {isEmpty} from '../../../../utils/common'
import Select from '../../../../components/Select/Select'
import {MIN_DATE_RANGE, profitPercentageDropdownOptions} from '../../utils'

const OrderReportHeader = () => {
  const {
    onDateChange,
    onSearch,
    salesReps,
    isSalesRepDropdownLoading,
    onChangeSalesRepFilter,
    customerGroups,
    isCustomerGroupsLoading,
    onChangeCustomerGroupFilter,
    onDownloadCSV,
    ordersReportData,
    isOrdersReportLoading,
    filters,
    hasOrderFilterApplied,
    onProfitPercentageChange,
    onResetFilters,
  } = useContext(OrderReportContext)
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')

  return (
    <div className='mb-10'>
      <div className='d-flex flex-wrap justify-content-between align-items-end'>
        <div>
          <Search
            onSearch={(searchTerm: string) => {
              onSearch && onSearch(searchTerm)
            }}
          />
        </div>

        <div className='d-flex gap-5 align-itens-end'>
          <ExportCSVButton
            onExportCSV={onDownloadCSV}
            isLoading={isOrdersReportLoading}
            hide={isEmpty(ordersReportData)}
          />

          <div className='w-175px'>
            <PredefinedDateRange
              cb={onDateChange}
              defaultValue={dateRangeLabel || 'Last 90 Days'}
              includeCurrantDay={true}
              startDate={MIN_DATE_RANGE}
            />
          </div>
        </div>
      </div>

      <div className='d-flex flex-wrap align-items-end gap-5 mt-10'>
        <MultiSelect
          id={`customer-group-filter`}
          label='Customer Group'
          options={customerGroups}
          valueType='number'
          className='w-175px'
          placeholder='Select Customer Group'
          allValuesSelectedText={'Customer Group: All'}
          isLoading={isCustomerGroupsLoading}
          handleSelected={onChangeCustomerGroupFilter}
          selectedValues={customerGroups?.filter((group) =>
            filters?.customer_group_id?.split(',')?.includes(group?.value?.toString())
          )}
        />
        <MultiSelect
          id={`sales-rep-filter`}
          label='Sales Rep'
          options={salesReps}
          className='w-175px'
          placeholder='Select Sales Rep'
          allValuesSelectedText={'Sales Rep: All'}
          isLoading={isSalesRepDropdownLoading}
          handleSelected={onChangeSalesRepFilter}
          selectedValues={salesReps?.filter((rep) =>
            filters?.sales_rep_email?.split(',')?.includes(rep?.value)
          )}
        />
        <Select
          id='is-profitable-filter'
          label='Profit Range'
          options={profitPercentageDropdownOptions}
          value={filters?.profit_percentage}
          className='w-150px'
          placeholder='Select Profit'
          isNullable={true}
          onChange={(e: any) => {
            onProfitPercentageChange(e?.target?.value)
          }}
        />

        {hasOrderFilterApplied && (
          <button className='btn btn-outline' onClick={onResetFilters}>
            Reset Filters
          </button>
        )}
      </div>
    </div>
  )
}

export default OrderReportHeader
